import {
  CLAUDE_FABLE_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_8_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_SONNET_5_DEFAULT_MODEL_CONFIG,
} from "@app/types/assistant/models/anthropic";
import {
  AUTO_COMPLEX_MODEL_CONFIG,
  AUTO_FAST_MODEL_CONFIG,
  AUTO_MODEL_CONFIG,
} from "@app/types/assistant/models/auto";
import {
  FIREWORKS_DEEPSEEK_V4_FLASH_0731_MODEL_CONFIG,
  FIREWORKS_DEEPSEEK_V4_PRO_MODEL_CONFIG,
  FIREWORKS_GLM_5P2_MODEL_CONFIG,
  FIREWORKS_INKLING_MODEL_CONFIG,
  FIREWORKS_KIMI_K2P6_MODEL_CONFIG,
  FIREWORKS_KIMI_K3_MODEL_CONFIG,
} from "@app/types/assistant/models/fireworks";
import {
  GEMINI_3_1_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_1_PRO_MODEL_CONFIG,
  GEMINI_3_5_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_5_FLASH_MODEL_CONFIG,
  GEMINI_3_6_FLASH_MODEL_CONFIG,
  GEMINI_3_7_FLASH_MODEL_CONFIG,
} from "@app/types/assistant/models/google_ai_studio";
import {
  MISTRAL_CODESTRAL_MODEL_CONFIG,
  MISTRAL_LARGE_MODEL_CONFIG,
  MISTRAL_MEDIUM_3_5_MODEL_CONFIG,
  MISTRAL_SMALL_MODEL_CONFIG,
} from "@app/types/assistant/models/mistral";
import {
  GPT_5_4_MINI_MODEL_CONFIG,
  GPT_5_4_NANO_MODEL_CONFIG,
  GPT_5_6_LUNA_MODEL_CONFIG,
  GPT_5_6_SOL_MODEL_CONFIG,
  GPT_5_6_TERRA_LONG_CONTEXT_MODEL_CONFIG,
  GPT_5_6_TERRA_MODEL_CONFIG,
} from "@app/types/assistant/models/openai";
import type { ModelConfig } from "@app/types/assistant/models/types";
import {
  GROK_4_5_MODEL_CONFIG,
  GROK_4_6_MODEL_CONFIG,
} from "@app/types/assistant/models/xai";

export const USED_MODEL_CONFIGS: readonly ModelConfig[] = [
  GPT_5_6_SOL_MODEL_CONFIG,
  GPT_5_6_TERRA_MODEL_CONFIG,
  GPT_5_6_TERRA_LONG_CONTEXT_MODEL_CONFIG,
  GPT_5_6_LUNA_MODEL_CONFIG,
  GPT_5_4_MINI_MODEL_CONFIG,
  GPT_5_4_NANO_MODEL_CONFIG,
  CLAUDE_SONNET_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_5_DEFAULT_MODEL_CONFIG,
  CLAUDE_OPUS_4_8_DEFAULT_MODEL_CONFIG,
  CLAUDE_FABLE_5_DEFAULT_MODEL_CONFIG,
  MISTRAL_LARGE_MODEL_CONFIG,
  MISTRAL_MEDIUM_3_5_MODEL_CONFIG,
  MISTRAL_SMALL_MODEL_CONFIG,
  MISTRAL_CODESTRAL_MODEL_CONFIG,
  GEMINI_3_1_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_1_PRO_MODEL_CONFIG,
  GEMINI_3_5_FLASH_LITE_MODEL_CONFIG,
  GEMINI_3_5_FLASH_MODEL_CONFIG,
  GEMINI_3_6_FLASH_MODEL_CONFIG,
  GEMINI_3_7_FLASH_MODEL_CONFIG,
  FIREWORKS_DEEPSEEK_V4_PRO_MODEL_CONFIG,
  FIREWORKS_DEEPSEEK_V4_FLASH_0731_MODEL_CONFIG,
  FIREWORKS_KIMI_K2P6_MODEL_CONFIG,
  FIREWORKS_KIMI_K3_MODEL_CONFIG,
  FIREWORKS_GLM_5P2_MODEL_CONFIG,
  FIREWORKS_INKLING_MODEL_CONFIG,
  GROK_4_6_MODEL_CONFIG,
  GROK_4_5_MODEL_CONFIG,
  AUTO_FAST_MODEL_CONFIG,
  AUTO_MODEL_CONFIG,
  AUTO_COMPLEX_MODEL_CONFIG,
] as const;
